import { ChangeEvent, FC } from 'react';

import { Formik } from 'formik';
import { isStrictEqual } from 'remeda';
import { BaseInput, FormBodyContainer } from 'wbs-components-lib';

import { VipLevelFormProps } from './types';
import { vipLevelValidationSchema } from './validationSchema';

import { FileSelector } from 'v2/components/fileSystem/fileSelector/FileSelector';

export const VipLevelForm: FC<VipLevelFormProps> = ({
  initialValues,
  onSubmit,
  isSubmitting = false,
  submitButtonCaption = 'Create',
}) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={vipLevelValidationSchema}
      enableReinitialize
    >
      {({ values, handleChange, handleBlur, setFieldValue, submitForm, errors, touched }) => {
        const { level: levelValue, title: titleValue, levelPoints: levelPointsValue, iconId: iconIdValue } = values;
        const { level: levelError, title: titleError, levelPoints: levelPointsError } = errors;
        const { level: isLevelTouched, title: isTitleTouched, levelPoints: isLevelPointsTouched } = touched;

        const isLevelError = isLevelTouched && !!levelError;
        const isTitleError = isTitleTouched && !!titleError;
        const isLevelPointsError = isLevelPointsTouched && !!levelPointsError;

        const isSubmitButtonDisabled = isStrictEqual(values, initialValues);

        return (
          <FormBodyContainer
            isSubmitting={isSubmitting}
            submitButtonCaption={submitButtonCaption}
            isSubmitButtonDisabled={isSubmitButtonDisabled}
            onSubmit={submitForm}
          >
            <BaseInput
              helperText={isLevelError && levelError}
              label="Enter level"
              id="level"
              name="level"
              isDisabled={true}
              caption="Level"
              value={levelValue}
              type="number"
              onBlur={handleBlur}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                setFieldValue('level', event.target.value);
              }}
              error={isLevelError}
            />
            <BaseInput
              helperText={isTitleError && titleError}
              label="Enter title"
              id="title"
              name="title"
              caption="Title"
              value={titleValue}
              onBlur={handleBlur}
              onChange={handleChange}
              error={isTitleError}
            />
            <BaseInput
              helperText={isLevelPointsError && levelPointsError}
              label="Enter level points"
              id="levelPoints"
              name="levelPoints"
              caption="Level Points"
              value={levelPointsValue}
              type="number"
              onBlur={handleBlur}
              onChange={handleChange}
              error={isLevelPointsError}
            />
            <FileSelector
              label="Level icon"
              value={iconIdValue}
              onSelect={(value) => setFieldValue('iconId', value)}
              required
            />
          </FormBodyContainer>
        );
      }}
    </Formik>
  );
};
